<template>
    <div class="center-center" v-show="!loading">
      <span class="center-title">最新文章</span>
      <div v-for="article in articles" :key="article.id" class="article">
        <div class="category">
          <span>{{ article.category }}</span>
        </div>
        <div class="article-box">
          <div class="article-title">
            <RouterLink :to="{name: 'post', params: {id: article.id}}">
              {{ article.title }}
            </RouterLink>
          </div>
          <div class="article-content">{{ article.summary }}</div>
        </div>
        <div class="article-info">
          <div>
            <span class="iconfont icon-riqishijian_line"></span>
            <span>{{ article.create_time }}</span>
          </div>
          <div>
            <span class="iconfont icon-tushu"></span>
            <span>{{ article.words }}字</span>
          </div>
          <div>
            <span class="iconfont icon-zuozhe"></span>
            <span>{{ article.username }}</span>
          </div>
          <div class="article-label">
            <span class="iconfont icon-biaoqian"></span>
            <div class="label-spans">
              <span class="article-label-span">#{{ article.tag }}</span>
            </div>
          </div>
        </div>
      </div>
      <div>
        <pagePagination v-if="totalpage > 1" @update:currentpage="handleClickPage" :islastpage="islastpage" :totalpage="totalpage" :currentPage="currentPage" />
        <!-- <pagePagination /> -->
      </div>
      <div class="footer">
        <div class="copy">
          <!-- 版权所有 -->
          <p style="font-size: 14px; margin-top: 5px;">&copy; 2026 青蛙计划。保留所有权利。</p>

          <!-- 个人网站的可选补充：友情免责 -->
          <p style="font-size: 14px; margin-top: 5px;">
            本站内容仅供学习交流，如有侵权请联系删除。
          </p>
          <p style="font-size: 14px; margin-top: 5px; display: flex; gap: 10px; flex-wrap: wrap;">
            <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13058102006867"
                rel="noreferrer"
                target="_blank"
                style="display: inline-flex; align-items: center;">
              <img src="@/assets/备案图标.png" alt="公安备案图标" style="width: 16px; height: 17px;">
              冀公网安备13058102006867号
            </a>
            <a href="https://beian.miit.gov.cn/" target="_blank">冀ICP备2023038551号-5</a>
          </p>
        </div>
      </div>

    </div>
    <div class="center-right" v-show="!loading">
      <div class="search-box">
        <span class="iconfont icon-search"></span>
        <input placeholder="搜索...">
      </div>
      <div class="category-box">
        <div class="category-title noselect">
          <span class="iconfont icon-leibiemoban"></span>分类
        </div>
        <div class="category-content">
          <span v-for="category in categories" :key="category.category_code" class="category noselect">{{ category.category_name }}</span>
        </div>
      </div>
      <div class="label-box">
        <div class="label-title noselect">
          <span class="iconfont icon-biaoqian"></span>标签
        </div>
        <div class="label-content">
          <span v-for="tag in tags" :key="tag.tag_code" class="label noselect">#{{ tag.tag_name }}</span>
        </div>
      </div>
    </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import pagePagination from '@/components/pagePagination.vue'
import request from '@/utils/request'
export default {
  name: 'HomeHome',
  components: { pagePagination },
  setup () {
    const loading = ref(true)
    const isLogin = ref(false)
    const userid = ref(undefined)

    const articles = ref([])
    const totalpage = ref(0)
    const islastpage = ref(false)
    const currentPage = ref(1)
    const categories = ref([])
    const tags = ref([])

    onMounted(() => {
      getAllArticle(1)
    })

    const getCategoriesTags = () => {
      request('/article/category', 'get').then(res => {
        categories.value = res.categories
        tags.value = res.tags
      }).catch(err => {
        return Promise.reject(err)
      })
    }

    // const doneLoading = inject('doneLoading')
    // 初始化请求文章接口
    const getAllArticle = (page) => {
      request('/article/all', 'get', { nextpage: page }).then(
        response => {
          articles.value = response.data.articles
          totalpage.value = response.data.totalpage
          islastpage.value = response.data.islastpage
          getCategoriesTags()
          loading.value = false // 显示页面
        }
      ).catch(err => {
        getCategoriesTags()
        loading.value = false // 显示页面
        return Promise.reject(err)
      })
    }

    const handleClickPage = (newPage) => {
      getAllArticle(newPage)
      currentPage.value = newPage
      // 获取实际滚动容器
      const scrollContainer = document.querySelector('.home-index')
      if (scrollContainer) {
        scrollContainer.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      } else {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        })
      }
    }

    return {
      getAllArticle,
      articles,
      islastpage,
      totalpage,
      currentPage,
      handleClickPage,
      categories,
      loading,
      isLogin,
      userid,
      tags
    }
  }
}
</script>

<style lang="less" scoped>
.center-center {
  flex: 4;
  padding: 10px 5px;
  .category{
    span {
      background-color: #999;
      padding: 8px 16px;
      border-radius: 7px;
    }
  }
  .center-title {
    margin-left: 15px;
    // background-color: #999;
    font-size: 18px;
  }
  .article {
    margin: 10px auto;
    padding: 25px;
    // border: 2px solid;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    gap: 15px;
    background-color: rgb(255, 255, 255);
    .article-box {
      display: flex;
      flex-direction: column;
      row-gap: 8px;
    }
    .article-title {
      font-size: 26px;
      font-weight: 600;
    }
    .article-content {
      font-size: 14px;
      font-weight: 400;
      // border: 2px dashed rgb(150, 150, 150);
      padding: 15px 10px;
      border-radius: 10px;
      background-color: rgb(240, 240, 240);
      line-height: 1.8em;
      text-indent: 2em;
    }
    .article-info {
      display: flex;
      column-gap: 40px;
      flex-wrap: wrap;
      div {
        display: flex;
        align-items: center;
        .iconfont {
          font-size: 14px;
        }
      }
    }
    .article-label {
      display: flex;
      gap: 0px;
      .iconfont {
        font-size: 14px;
      }
      .label-spans {
        display: flex;
        gap: 10px;
        .article-label-span {
          padding: 0 7px;
          background-color: rgb(236, 253, 245);
          border-radius: 6px;
          border: 1px solid rgb(209, 250, 229)
        }
      }
    }
  }
  .footer {
    margin-bottom: 20px;
    // height: 100px;
    // width: 100vh;
    // background-color: antiquewhite;
    // background-color: rgb(255, 255, 255);
    padding: 20px 20px;
    .copy {
      margin: auto auto;
    }
    @media (max-width: 768px) {
      height: 150px;
    }
  }
}
.center-right {
  flex: 1;
  padding-top: 10px;
  position: sticky;
  top: 0;
  max-height: 100vh;
  @media (max-width: 768px) {
    display: none;
  }
  .search-box {
    display: flex;
    align-items: center;
    border: 1px solid #ddd;
    border-radius: 20px;
    padding: 10px;
    background-color: rgb(255, 255, 255);
    input {
      flex: 1;
      font-size: 14px;
    }
    .iconfont {
      line-height: 1;
      font-size: 18px;
      color: #999
    }
  }
  .category-box {
    margin-top: 10px;
    // background-color: rgb(255, 255, 255);
    padding: 10px 10px;
    .category-title {
      margin-bottom: 10px;
    }
    .category-content {
      display: flex;
      gap: 10px;
      flex-wrap: wrap;
      .category {
        background-color: rgb(255, 255, 255);
        padding: 8px 20px;
        border-radius: 7px;
      }
    }
  }
  .label-box {
    margin-top: 10px;
    // background-color: rgb(255, 255, 255);
    padding: 10px 10px;
    height: 300px;
    border-radius: 20px;
    .label-content {
      display: flex;
      column-gap: 10px;
      margin-top: 10px;
      .label {
        background-color: rgb(255, 255, 255);
        padding: 8px 20px;
        border-radius: 7px;
      }
    }
  }
}
</style>>
